import { gql, TypedDocumentNode } from '@common/hooks';

export const DeleteComplianceFileMutation: TypedDocumentNode<
  DeleteComplianceFileMutationResponse,
  DeleteComplianceFileMutationArgs
> = gql`
  mutation DeleteComplianceFileMutation($id: ID!, $worksListItemId: ID!) {
    deleteComplianceFile(id: $id, worksListItemId: $worksListItemId) {
      id
      success
    }
  }
`;

type DeleteComplianceFileMutationArgs = {
  id: string;
  worksListItemId: string;
};

type DeleteComplianceFileMutationResponse = {
  id: string;
  success: boolean;
};
